<template>
    <transition name="fade">
        <Error :errorMessage="errorMessage" v-if="errorModal" @hideErrorMessage="hideErrorMessage"></Error>
    </transition>
</template>

<script>
import Error from './views/plugin/error';

export default {
    name: "AutoLogout",
    data: function () {
        return {
            events : ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
            logoutTimer: null,
            errorModal:false,
            errorMessage : '',
        }
    },
    mounted() {
        this.events.forEach(function(event) {
            window.addEventListener(event, this.resetTimer);
        }, this);
        this.setTimers();
    },
    destroyed() {
        this.events.forEach(function(event) {
            window.removeEventListener(event, this.resetTimer);
        }, this);
        this.resetTimer();
    },
    methods: {
        setTimers: function() {
            this.logoutTimer = setTimeout(this.logoutUser, 5 * 60 * 1000);
        },
        logoutUser : function () {
            var tokenId =  localStorage.getItem("authToken");
            var user = this.$auth.getMe();
            if(tokenId !== null && user !== null){
                this.errorModal = true;
                this.errorMessage = 'Таны аюулгүй байдлын үүднээс систем дээр 5 минут үйлдэл хийгээгүй тул холболтыг түр салгалаа. Дахин нэвтэрнэ үү.';
                this.$auth.destroyToken();
                this.$auth.removeMe();
                this.$router.push({ name: 'login' });
            }
        },
        resetTimer: function () {
            clearTimeout(this.logoutTimer);
            
            this.setTimers();
        },
        hideErrorMessage(){
            this.errorMessage = '',
            this.errorModal = false;
        },
    },
    components : {
        Error
    }
}
</script>